var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "#ececec",
    stroke: "#ececec",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.5 2.299.006.005 5.997 5.257a2.25 2.25 0 0 1 .747 1.685V18A2.25 2.25 0 0 1 15 20.25H3A2.25 2.25 0 0 1 .75 18V9.254a2.25 2.25 0 0 1 .748-1.693l5.997-5.257.005-.005a2.25 2.25 0 0 1 3 0Zm.5 17.45h.75V14A1.75 1.75 0 0 0 10 12.25H8A1.75 1.75 0 0 0 6.25 14v5.75H11Zm1.25-.75v.75H15A1.75 1.75 0 0 0 16.75 18V9.25a1.75 1.75 0 0 0-.595-1.313h-.001l-5.999-5.25a1.75 1.75 0 0 0-2.31 0l-5.999 5.25A1.75 1.75 0 0 0 1.25 9.25V18A1.75 1.75 0 0 0 3 19.75h2.75V14A2.25 2.25 0 0 1 8 11.75h2A2.25 2.25 0 0 1 12.25 14v5Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.4ddd34190109d8d78a7b76f2a16a10d6.svg";
export { ForwardRef as ReactComponent };